/**
 * 获取关注状态
 * @param user_id
 * @returns 0 - 未关注; 1 - 已关注; 2 - 互相关注
 */
export async function fetchFollowStatus(user_id: number) {
  if (!useUserInfo().value.login) {
    return 0
  }
  return http
    .get<{ status: number }>('/v1/follow/status', {
      user_id
    })
    .then((res) => res.data.status)
    .catch(() => 0)
}
